<template>
  <q-dialog
    v-model="shown"
    :maximized="supportArticle && supportArticle.type === 'Article'"
    :full-width="supportArticle && supportArticle.type === 'Video'"
    transition-show="fade-in"
    transition-hide="fade-out"
  >
    <template
      v-if="supportArticle"
    >
      <q-card
        v-if="supportArticle.type === 'Article'"
      >
        <div class="row q-ma-sm justify-between">
          <div
            class="col-auto"
          />
          <div class="col-auto text-h6">
            {{ supportArticle.title }}
          </div>
          <q-btn
            v-close-popup
            class="col-auto"
            icon="close"
            flat
            round
            dense
          />
        </div>
        <q-card-section>
          <div
            class="row q-col-gutter-md column-container"
          >
            <div
              class="col-12"
            >
              <div
                class="scroll q-pa-lg smooth-scroll"
                style="border: solid 1px #EEE; border-radius: 2px;"
              >
                <markdown-content
                  :content="supportArticle.content"
                />
              </div>
            </div>
          </div>
        </q-card-section>
      </q-card>
      <q-video
        v-if="supportArticle.type === 'Video'"
        style="width: 100%"
        :ratio="16/9"
        :src="supportArticle.videoUrl"
      />
    </template>
  </q-dialog>
</template>

<script>
import MarkdownContent from 'src/modules/admin/components/MarkdownContent.vue'

export default {
  name: 'SupportArticleDialog',
  components: {
    MarkdownContent
  },
  props: {
    modelValue: {
      type: Boolean,
      required: false
    },
    supportArticle: {
      type: Object,
      required: false,
      default: null
    }
  },
  emits: ['update:model-value', 'close'],
  data () {
    return {
      shown: false
    }
  },
  watch: {
    modelValue () {
      this.shown = this.modelValue
    },
    shown () {
      this.$emit('update:model-value', this.shown)

      if (!this.shown) {
        this.$emit('close')
      }
    }
  }
}

</script>

<style lang="scss" scoped>
.smooth-scroll {
  scroll-behavior: smooth;
}
</style>
